<script>

    import {API, copyObj, extraData$} from "../../lib/lib.js";
    import ExtraDataItem from "./ExtraDataItem.svelte";
    import ScreenCenter from "../ScreenCenter.svelte";
    import PairEditor from "../varius/PairEditor.svelte";
    import ErrorDisplay from "../layout/ErrorDisplay.svelte";
    import Icon from "../layout/Icon.svelte";

    let selectedExtra = null;
    let editorVisible = false;
    let errors = null;

    const closeEditor = () => editorVisible = false;

    const showEditor = ({detail: data}) => {
        data = data || {text:'', default:''};
        selectedExtra = copyObj(data);
        editorVisible = true;
    };

    const saveExtra = async () => {
        errors = '';
        selectedExtra.text = selectedExtra.text.trim();
        if (selectedExtra.text.length < 2) {
            errors = ['Πρέπει να δώσετε ένα σωστό τίτλο'];
            return;
        }

        const doEdit = async data => {
            const res = await API.patch(`extraData/${data.id}`, data);

            if (hasError(res.error)) {
                return;
            }

            extraData$.update(store => {
                return store.map(ed => {
                    if (ed.id == data.id) {
                        ed.text = data.text;
                        ed.default = data.default;
                    }
                    return ed;
                });
            });

            showMessage('Αποθηκεύτηκε!');
            closeEditor();
        };

        const doAdd = async extraData => {
            const res = await API.post(`extraData`, extraData);
            if (hasError(res.error)) {
                return;
            }

            $extraData$ = [...$extraData$, res.data];
            showMessage('Αποθηκεύτηκε!');
            selectedExtra = null;
            editorVisible = false;
        };

        const hasError = arg => {
            if (arg == true) {
                errors = res.errors;
                showMessage('Κάποιο λάθος συνέβη');
                return true;
            }

            return false;
        };

        if (selectedExtra.id) {
            doEdit(selectedExtra);
        } else {
            doAdd(selectedExtra);
        }
    };


</script>


<div class="main-place">
    {#each $extraData$ as data}
        <ExtraDataItem on:edit={showEditor} {data}/>
    {/each}

    <div class="p-sm bg-white flex items-center gap-sm justify-end">
        <button class="btn px-sm flex gap-2 text-sm" on:click={() => showEditor({})}>
            <Icon color="00aa00" icon="plus-circle"/>
            <span>Τύπος</span>
        </button>
    </div>
</div>


{#if editorVisible}
    <ScreenCenter title="{selectedExtra?.id ?  'Επεξεργασία' : 'Προσθήκη'}" on:close={closeEditor}>
        <PairEditor full title="Κείμενο">
            <input type="text" bind:value={selectedExtra.text}>
        </PairEditor>
        <PairEditor full title="Default τιμή">
            <input type="text" bind:value={selectedExtra.default}>
        </PairEditor>
        <div class="help text-xs">
            Αφήστε το κενό ώστε να εμφανίζεται σαν check
        </div>

        <ErrorDisplay bind:errors/>
        <hr>
        <div class="text-right">
            <button class="btn btn-link underline" on:click={closeEditor}>Κλείσιμο</button>
            <button class="btn btn-ok" on:click={saveExtra}>Αποθήκευση</button>
        </div>
    </ScreenCenter>
{/if}



